import { Component, OnInit, Input } from '@angular/core';
// import { UploadReportComponent } from '../../modal-popups/upload-report/upload-report.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-report-upload-link',
  templateUrl: './report-upload-link.component.html',
  styleUrls: ['./report-upload-link.component.scss']
})
export class ReportUploadLinkComponent implements OnInit {

  constructor(private modalService: NgbModal,) { }
  @Input() role;
  @Input() orderDetailsObj;
  msg: string = "";
  
  ngOnInit(): void {


    if (this.role != 97 || (this.role == 97 && this.orderDetailsObj !=undefined && this.orderDetailsObj.order !=undefined && this.orderDetailsObj.order.business !=undefined  && this.orderDetailsObj.order.business.isUCDOrder !=undefined && this.orderDetailsObj.order.business.isUCDOrder == 1)) {
      this.msg = "Upload";

    }
  }

  


  openUploadReportItemModal(orderObj) {
//     //console.log("report upload called");
//     //console.log(orderObj);
//     const modalRef = this.modalService.open(UploadReportComponent);

//     const closeModelRef = modalRef.result.then(
//       (res) => {
// //console.log(res);
//        // this.getOrderDataById(this.id);

//       }

//     );

//     modalRef.componentInstance.orderObj = orderObj;

  }
  
}
